import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import {AppService} from '@irb/app.service';
import {IrbOrdersService} from "@irb/irb-orders/irb-orders.service";
import { IrbAppEvents } from '@irb/app.events';
import { IAlertDialogData } from '@irb/app.model';
import {Observable, Subscription, interval} from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class IrbOrdersGuard  {
    checkMasterAccessSub: Subscription;
    url: string;
    isUiTest = false;

    constructor(private os: IrbOrdersService, public as: AppService, private router: Router) {}

    canActivate(_route: ActivatedRouteSnapshot, _nextState: RouterStateSnapshot) : Observable<boolean> {
          const accessUpdated = _route.queryParamMap.get("accessUpdated");

          return this.os.getMasterAccountsAccess().pipe(
                map(res => {
                    if(!res?.responseData?.isMasterAccountsAccessChanged || accessUpdated === "true") {
                        return true;
                    } else if(res?.responseData?.lostMaster?.length > 0) {
                      let s = res.responseData.lostMaster.join("</br>");

                      if(res.responseData.lostMaster?.length > 3) {
                        s = "<div style='max-height: 60px; overflow-y: auto; border: 1px solid #CCCCCC; padding: 5px;'>" + s + "</div>";
                      }

                      this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION,{
                        dTitle: "Blotter Access Restricted",
                        dType: 'WARN',
                        msg:  "You no longer have access to the following master account(s). To access the blotter your access will need to be updated. Click Continue to update your user access. While your access is being updated iRebal will be unavailable.",
                        altMsgHTML: s,
                        dCancelBtnLabel: "Cancel",
                        dProceedBtnLabel: "Continue",
                        onProceed: () => {
                          this.url = _nextState.url;
                          this.updateMaster(res.responseData.lostMaster); 
                        },
                        onCancel: () => {}
                      } as IAlertDialogData);

                      return false;
                    } else {
                      this.as.fireEvent(IrbAppEvents.SHOW_ALERT,{
                        dTitle: "Blotter Access Restricted",
                        dType: 'WARN',
                        msg:  "Access to the blotter has been restricted. This is likely caused by a change in your user access. Please consult with your firm's security administrator for information regarding changes to your access."
                      } as IAlertDialogData);

                      return false;
                    }
                }
          ));
    }

    updateMaster(lostMaster: Array<number>) {
      this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
      
      this.os.updateMasterAccessAsync({lostMaster: lostMaster}).subscribe((res: any) => {
        this.checkMasterAccessAsyncStatus(res.responseUtilityMap.rprasId);
      });
    }

    checkMasterAccessAsyncStatus(rprasId: string) {
        const timeInterval = this.isUiTest ? 0 : 3000;
      this.checkMasterAccessSub = interval(timeInterval).subscribe(() => {
        this.os.checkMasterAccessStatus(rprasId).subscribe((res: any) => {
          if(res.status.toUpperCase() == "COMPLETED") {
            this.checkMasterAccessSub.unsubscribe();
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            this.completeNavigation();
          } else if(res.status.toUpperCase() == "FAILED") {
            this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
              dType: 'ERROR',
              dTitle: '',
              dProceedBtnLabel: '',
              msg: res.failMsg,
              onProceed: () => {}
            } as IAlertDialogData);
            this.checkMasterAccessSub.unsubscribe();
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          } else if(res.status.toUpperCase() == "INPROGRESS") {
          }
        });
      });
    }

    completeNavigation() {
      this.router.navigate([this.url], {queryParams: {'accessUpdated': true}});
    }
}
